const style = {
  wrapper: {
    margin: `15px -15px`
  },
  list: {
    // background: `#fbfbfb`,
  },
  row: {
    border: `1px solid transparent`,
    padding: `20px`,
    borderBottom: `1px solid #f4f4f4`,
    cursor: `pointer`
  },
  rowActive: {
    background: `#fbfbfb`
  },
  header: {
    borderBottom: `1px solid #ececec`
  },
  p: {
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/style/list.js